import {FAQs} from '~/components/FAQs'
import { MTDHeader } from '~/components/MTDHeader'

export default () => <main>
  <MTDHeader />
  <FAQs />
</main>